module.exports = __webpack_public_path__ + "static/media/youtube.7d44f482.svg";